// extracted by mini-css-extract-plugin
export default {"tasks":"HN-z","task":"IN-z","svg":"JN-z","text":"KN-z"};